export default __webpack_public_path__ + "static/bidrequest-e78f000d491683ef015233ddc2a06776.svg";